import React, { useState } from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Typography,
  IconButton,
  Box,
} from '@mui/material'
import { TASK_TYPE_MODAL_DISPLAY_NAMES } from '../constants'
import CustomerSearch from '../common/CustomerSearch'
import { Close } from '@mui/icons-material'
import useCustomerContacts from '../hooks/api/useCustomerContacts'

const TaskTypeSelectorModal = ({
  currentOpenModalStaging,
  setCurrentOpenModal,
  setCurrentOpenModalStaging,
  currentOpenModal,
  selectedCustomer,
  setSelectedCustomer,
  selectedContact,
  setSelectedContact,
}) => {
  const [customerSearchQuery, setCustomerSearchQuery] = useState('')

  const { customerContacts } = useCustomerContacts(
    selectedCustomer?.id,
    '',
    {},
    { skip: currentOpenModal !== 'selector' }
  )

  const handleContactSelect = (id) => {
    setSelectedContact(customerContacts.find((c) => c.id === id))
  }

  const taskKeys = [
    ...Object.keys(TASK_TYPE_MODAL_DISPLAY_NAMES).filter((key) => key !== '5'),
    '5',
  ]

  return (
    <Dialog
      open={currentOpenModal === 'selector'}
      fullWidth
      maxWidth={'sm'}
      onClose={() => setCurrentOpenModal(null)}
    >
      <DialogTitle>Create a task</DialogTitle>
      <DialogContent>
        {!selectedCustomer && (
          <CustomerSearch
            margin={'dense'}
            onSelect={setSelectedCustomer}
            allowAdd={false}
            searchQuery={customerSearchQuery}
            setSearchQuery={setCustomerSearchQuery}
          />
        )}

        {selectedCustomer && (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>
                Account: <b>{selectedCustomer.name}</b>
              </Typography>
              <IconButton onClick={() => setSelectedCustomer(null)}>
                <Close />
              </IconButton>
            </Box>

            <TextField
              margin='dense'
              fullWidth
              label='Contact (optional)'
              value={selectedContact?.id || ''}
              onChange={(e) => handleContactSelect(e.target.value)}
              select
            >
              {customerContacts.length === 0 && (
                <MenuItem disabled>No contacts found</MenuItem>
              )}

              <MenuItem value={null}>None</MenuItem>
              {customerContacts.map((c, i) => (
                <MenuItem key={i} value={c.id}>
                  {`${c.firstName} ${c.lastName}`}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}

        <TextField
          select
          label={'Task type'}
          value={currentOpenModalStaging}
          onChange={(e) => setCurrentOpenModalStaging(Number(e.target.value))}
          sx={{ mt: 1 }}
        >
          {taskKeys.map((key) => (
            <MenuItem key={key} value={key}>
              {TASK_TYPE_MODAL_DISPLAY_NAMES[key]}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setCurrentOpenModal(null)}>Cancel</Button>
        <Button
          disabled={!currentOpenModalStaging || !selectedCustomer}
          variant={'contained'}
          onClick={() => {
            setCurrentOpenModal(currentOpenModalStaging)
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TaskTypeSelectorModal
